var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("entity-editor", {
    attrs: { entity: "plot", id: _vm.id, "new-entity": _vm.newPlot },
    on: { isDirtyChange: _vm.handleIsDirtyChange },
    scopedSlots: _vm._u(
      [
        {
          key: `editor`,
          fn: function({ doc }) {
            return [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Plot Name",
                          rules: [_vm.requiredRule]
                        },
                        model: {
                          value: doc.name,
                          callback: function($$v) {
                            _vm.$set(doc, "name", $$v)
                          },
                          expression: "doc.name"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("large-text-editor", {
                        attrs: { label: "Details", rules: [_vm.requiredRule] },
                        model: {
                          value: doc.details,
                          callback: function($$v) {
                            _vm.$set(doc, "details", $$v)
                          },
                          expression: "doc.details"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          }
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }